export const ONE_MINUTE_MS = 60 * 1000

export const FIVE_MINUTES_MS = 5 * ONE_MINUTE_MS

export const TEN_MINUTES_MS = 10 * ONE_MINUTE_MS

export const FIFTEEN_MINUTES_MS = 15 * ONE_MINUTE_MS

export const THIRTY_MINUTES_MS = 30 * ONE_MINUTE_MS

export const ONE_HOUR_MS = 60 * ONE_MINUTE_MS

export const TWO_HOURS_MS = 2 * ONE_HOUR_MS

export const THREE_HOURS_MS = 3 * ONE_HOUR_MS

export const FOUR_HOURS_MS = 4 * ONE_HOUR_MS

export const FIVE_HOURS_MS = 5 * ONE_HOUR_MS

export const SIX_HOURS_MS = 6 * ONE_HOUR_MS

export const SEVEN_HOURS_MS = 7 * ONE_HOUR_MS

export const EIGHT_HOURS_MS = 8 * ONE_HOUR_MS

export const NINE_HOURS_MS = 9 * ONE_HOUR_MS

export const TEN_HOURS_MS = 10 * ONE_HOUR_MS

export const ELEVEN_HOURS_MS = 11 * ONE_HOUR_MS

export const TWELVE_HOURS_MS = 12 * ONE_HOUR_MS

export const THIRTEEN_HOURS_MS = 13 * ONE_HOUR_MS

export const FOURTEEN_HOURS_MS = 14 * ONE_HOUR_MS

export const FIFTEEN_HOURS_MS = 15 * ONE_HOUR_MS

export const SIXTEEN_HOURS_MS = 16 * ONE_HOUR_MS

export const SEVENTEEN_HOURS_MS = 17 * ONE_HOUR_MS

export const EIGHTEEN_HOURS_MS = 18 * ONE_HOUR_MS

export const NINETEEN_HOURS_MS = 19 * ONE_HOUR_MS

export const TWENTY_HOURS_MS = 20 * ONE_HOUR_MS

export const TWENTY_ONE_HOURS_MS = 21 * ONE_HOUR_MS

export const TWENTY_TWO_HOURS_MS = 22 * ONE_HOUR_MS

export const TWENTY_THREE_HOURS_MS = 23 * ONE_HOUR_MS

export const TWENTY_FOUR_HOURS_MS = 24 * ONE_HOUR_MS

export const ONE_DAY_MS = TWENTY_FOUR_HOURS_MS

export const SEVEN_DAYS_MS = 7 * ONE_DAY_MS

export const ONE_MONTH_MS = 30 * ONE_DAY_MS

export const FOREVER_MS = 30 * 365 * ONE_DAY_MS

export const NINETY_DAYS_MS = 90 * ONE_DAY_MS

export const TWENTY_FOUR_HOURS_SECONDS = 24 * 60 * 60

export const NINETY_DAYS_SECONDS = 90 * TWENTY_FOUR_HOURS_SECONDS

// 新用户赠送10积分商品名称
export const NEW_USER_FREE_10 = 'NEW_USER_FREE_10'

// 新用户赠送10积分商品ID
export const NEW_USER_FREE_10_PRODUCT_ID = 'prod_new_user_free_10'

// 新用户赠送20积分商品名称
export const NEW_USER_FREE_20 = 'NEW_USER_FREE_20'

// 新用户赠送20积分商品ID
export const NEW_USER_FREE_20_PRODUCT_ID = 'prod_new_user_free_20'

// 训练任务积分
export const TRAIN_TASK_CREDITS = 10

// 翻唱任务积分
export const COVER_TASK_CREDITS = 5

// 新翻唱任务积分（KIE 新链路）
export const COVER_GENERATION_TASK_CREDITS = 20

// TTS 每 1000 字符积分
export const TTS_CREDITS_PER_1000_CHARS = 8

// 默认音乐生成积分
export const MUSIC_DEFAULT_CREDITS = 10

// 上传音频asr解析歌词成功后积分
export const REFERENCE_ASR_LYRICS_CREDITS = 1

// 默认分页大小
export const DEFAULT_PAGE_SIZE = 20

// 唇型同步任务积分
export const LIP_SYNC_CREDITS = 30
